<template lang="pug">
#card
    h5.title(v-if='title') {{ title }}

    slot
    .informacao(v-if='info')
        i.information-card.mdi.mdi-information-outline(v-if='info')
        h5
            em {{ info }}
</template>

<script>
export default {
    name: 'Card',

    props: {
        title: {
            type: String
        },
        info: {
            type: String
        }
    }
};
</script>

<style lang="scss" scoped>
#card {
    height: 100%;
    border-radius: 5px;
    background-color: var(--white);
    border: solid 1px var(--default-border-color);
    padding: 20px;
    position: relative;

    .title {
        padding: 10px 0 0 20px;
        font-weight: map_get($font-weight, medium);
    }

    .informacao {
        display: flex;
        align-items: baseline;
        margin: 10px 0 0 20px;

        .information-card {
            cursor: pointer;
            color: var(--primary);
            margin-right: 5px;
        }
    }
}
</style>
